import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NSUrlsConstants } from '@ruby/configs/urls.constants';
import { IAccessorial, IAccessorialRequest, ILeaseTrackResponse } from '@ruby/modules/accessorial-inventory/models/accessorial-inventory.interface';

@Injectable({
  providedIn: 'root'
})
export class AccessorialInventoryService {

  constructor(private http: HttpClient) { }

  /**
   * Fetch Accessorial Details
   *
   * @summary Fetch the accessorial details
   * @param payload: IAccessorialRequest
   * @returns Observable<IAccessorial | never>
   */
  fetchAccessorialDetails(payload: IAccessorialRequest): Observable<IAccessorial | never> {
    return this.http.post(NSUrlsConstants.accessorialUrl, payload).pipe(
      map(response => response as IAccessorial)
    );
  }

  /**
   * Fetch Lease Track Details
   *
   * @summary Fetch the lease track details
   * @param payload: IAccessorialRequest
   * @returns Observable<ILeaseTrackResponse | never>
   */
  fetchLeaseTrackDetails(payload: IAccessorialRequest): Observable<ILeaseTrackResponse | never> {
    return this.http.post(NSUrlsConstants.accessorialLeaseTrackUrl, payload).pipe(
      map(response => response as ILeaseTrackResponse)
    );
  }
}
